import {
  FETCH_MONTHLY_ENTRIES_START,
  FETCH_MONTHLY_ENTRIES_SUCCESS,
  FETCH_MONTHLY_ENTRIES_FAIL,
} from '../actions/actionTypes.js'

const INITIAL_STATE = {
  entries: [],
  isFetching: true,
  errorMessage: '',
}

const monthlyEntriesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_MONTHLY_ENTRIES_START:
      return {
        ...state,
        isFetching: true,
        errorMessage: '',
      }
    case FETCH_MONTHLY_ENTRIES_SUCCESS:
      return {
        ...state,
        entries: action.payload,
        isFetching: false,
        errorMessage: '',
      }
    case FETCH_MONTHLY_ENTRIES_FAIL:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.payload,
      }
    default:
      return state
  }
}

export default monthlyEntriesReducer
